import React from 'react';
import { motion } from 'framer-motion';
import { AuraRing } from './AuraRing';
import { hiResAvatar } from '../utils/avatar';

/* Crystal-animal backdrop for Bliss Society crest cards. */
const CrestBackdrop = ({ crest }) => (
  <>
    <img src={crest.img} alt="" aria-hidden="true"
      className="absolute inset-0 w-full h-full object-cover pointer-events-none"
      style={{ opacity: 0.3, filter: 'saturate(1.1)' }}/>
    <div className="absolute inset-0 pointer-events-none"
      style={{ background: `linear-gradient(180deg, ${crest.tint}55 0%, rgba(3,3,6,0.78) 55%, rgba(3,3,6,0.95) 100%)` }}/>
    <div className="absolute inset-0 pointer-events-none crest-sheen"
      style={{ background: `linear-gradient(115deg, transparent 30%, ${crest.accentSoft}33 48%, transparent 62%)` }}/>
  </>
);

/* Square member card used by Bliss Global Users and the Society crest lists. */
export const MemberCard = ({ u, idx, accent, onOpen, testId, rank, stat, gold = false, crest = null }) => (
  <motion.button
    initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
    transition={{ delay: (idx % 8) * 0.04 }}
    whileTap={{ scale: 0.96 }}
    onClick={onOpen}
    data-testid={testId}
    className="relative rounded-2xl p-4 flex flex-col items-center text-center overflow-hidden"
    style={{
      background: crest ? '#030306' : `linear-gradient(180deg, ${accent}24, #05050A 75%)`,
      border: crest ? `1.5px solid ${accent}` : `1px solid ${accent}80`,
      boxShadow: `0 6px 18px rgba(0,0,0,0.5), 0 0 22px ${accent}2E inset, 0 0 ${crest ? 18 : 12}px ${accent}${crest ? '44' : '22'}`,
    }}>
    {crest && <CrestBackdrop crest={crest}/>}
    {rank != null && (
      <span className="absolute top-2 left-2 z-[1] px-1.5 rounded-full font-['Outfit'] text-[10px] tracking-[0.1em]"
        style={{ color: crest ? crest.rankText : accent, border: `1px solid ${accent}99`,
          background: crest ? `linear-gradient(180deg, ${crest.accentSoft}, ${accent})` : 'rgba(0,0,0,0.5)' }}
        data-testid={`${testId}-rank`}>#{rank}</span>
    )}
    <div className="relative z-[1] w-20 h-20 mb-3">
      <AuraRing size={80} data={u.aura_ring || { fused: {}, gold }}>
        <div className="w-16 h-16 rounded-full overflow-hidden border-2"
          style={{ borderColor: `${accent}AA`, boxShadow: `0 0 16px ${accent}66` }}>
          {u.profile_picture
            ? <img src={hiResAvatar(u.profile_picture)} alt={u.nickname} className="w-full h-full object-cover"/>
            : <div className="w-full h-full flex items-center justify-center text-2xl font-['Cormorant_Garamond']"
                style={{ background: `linear-gradient(135deg, ${accent}55, #05050A)`, color: accent }}>
                {(u.nickname || u.email || 'A')[0].toUpperCase()}
              </div>}
        </div>
      </AuraRing>
    </div>
    <div className={`relative z-[1] font-['Cormorant_Garamond'] text-white text-[16px] leading-tight truncate w-full ${stat ? 'mb-1' : 'mb-3'}`}
      style={crest ? { textShadow: `0 0 10px ${accent}88` } : undefined}>
      {u.nickname || u.email?.split('@')[0] || 'Member'}
    </div>
    {stat && (
      <div className="relative z-[1] font-['Outfit'] text-[9.5px] uppercase tracking-[0.16em] mb-2.5" style={{ color: crest ? crest.accentSoft : `${accent}CC` }}
        data-testid={`${testId}-stat`}>{stat}</div>
    )}
    <span className="relative z-[1] font-['Outfit'] uppercase tracking-[0.18em] rounded-full px-4 py-1.5"
      style={{ color: crest ? crest.accentSoft : accent, border: `1px solid ${accent}88`, background: crest ? 'rgba(0,0,0,0.55)' : `${accent}12`, fontSize: 10 }}>
      View Vibes
    </span>
  </motion.button>
);

export default MemberCard;
